var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[(!_vm.profile)?_c('Auth'):_vm._e(),(_vm.profile)?_c('Chat'):_vm._e(),_c('audio',{attrs:{"id":"newDialog","src":"/audio/newDialog.mp3","preload":"auto"}}),_c('audio',{attrs:{"id":"newMessage","src":"/audio/newMessage.mp3","preload":"auto"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }